import { HealthGoalsScreen } from '@/components/HealthGoalsScreen';

export default function HealthGoals() {
  return <HealthGoalsScreen />;
}
